<template>
  <base-material-card color="primary" icon="mdi-finance" inline class="px-5 py-5">
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        {{ titulo }}
      </div>
    </template>
    <v-form class="pt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="py-0">
          <v-alert dense outlined type="warning" color="#FB8C00">
            <div>
              Ao salvar alterações nessa tela, os índices serão replicados em
              <strong>TODOS OS SISTEMAS</strong>
              , ou seja, caso cometa erros, irá replicar dados errados para os demais sistemas, e em todas as empresas. Muita
              atenção ao atualizar os dados. Siga por sua conta e risco!
            </div>
          </v-alert>
        </v-col>
      </v-row>
      <v-row align="center" class="mx-auto">
        <v-col cols="4" class="py-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="campo-data-referencia-indice-ipca"
              :value="mesReferencia | formatToMonth"
              label="Mês de Referência"
              outlined
              disabled
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
        <v-col cols="4" class="py-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="campo-variacao-ipca"
              v-model="variacaoMes"
              label="Variação no Mês"
              outlined
              :disabled="item.IndiceOficial == 'Não' ? false : true"
              :error-messages="errors"
              @input="calcularVariacaoMes($event)"
            />
          </validation-provider>
        </v-col>
        <v-col cols="4" class="py-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="campo-indice-ipca"
              v-model="indiceMes"
              type="number"
              label="Índice no Mês"
              outlined
              :disabled="item.IndiceOficial == 'Sim' || !$route.params.data_registro ? false : true"
              :error-messages="errors"
              @input="calcularVariacaoMes($event)"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import dayjs from 'dayjs';
  import AtualizacaoIndicesService from '@/services/AtualizacaoIndicesService';

  export default {
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },

    data: () => ({
      mesReferencia: '',
      variacaoMes: '',
      indiceMes: '',
      indiceAnterior: ''
    }),

    computed: {
      titulo() {
        return this.$route.params.data_registro ? 'Editar Indice IPCA' : 'Adicionar Índice IPCA';
      }
    },
    created() {
      this.popularCampos();
    },

    methods: {
      popularCampos() {
        if (this.$route.params.data_registro) {
          this.mesReferencia = this.item.DataRegistro;
          this.getIpcaAnterior();
        } else {
          this.getUltimoIpca();
        }
      },

      getUltimoIpca() {
        AtualizacaoIndicesService.getUltimoIndiceIpca()
          .then((indice) => {
            this.indiceAnterior = indice.indice_oficial;
            this.mesReferencia = dayjs(this.indiceAnterior.DataRegistro).add(1, 'month').format('YYYY-MM-DD');
          })
          .catch(() => this.$toast.error('Erro ao buscar ultimo Índice IPCA.', '', { position: 'topRight' }));
      },

      getIpcaAnterior() {
        const dataAnterior = dayjs(this.mesReferencia).subtract(1, 'month').format('YYYY-MM-DD');
        AtualizacaoIndicesService.getIndiceByDataRegistro(dataAnterior)
          .then((indice) => {
            this.indiceAnterior = indice.indice_oficial;
          })
          .catch(() => this.$toast.error('Erro ao buscar Índice IPCA anterior.', '', { position: 'topRight' }))
          .finally(() => {
            this.variacaoMes = this.item.VariacaoMes;
            this.indiceMes = this.item.IndiceMes;
          });
      },

      calcularVariacaoMes(valorCampo) {
        if (this.item.IndiceOficial == 'Não') {
          this.indiceMes = ((1 + valorCampo / 100) * this.indiceAnterior.IndiceMes).toFixed(2);
        } else {
          this.variacaoMes = ((valorCampo - this.indiceAnterior.IndiceMes) / (this.indiceAnterior.IndiceMes / 100)).toFixed(2);
        }
      },

      exportData() {
        return {
          NomeIndice: 'IPCA',
          VariacaoMes: this.variacaoMes,
          IndiceMes: this.indiceMes,
          DataRegistro: this.mesReferencia
        };
      }
    }
  };
</script>